















































































































































import { Vue, Component } from 'vue-property-decorator';
import ShuttleBox from '@/components/shuttleBox/choseDept.vue';
import ShuttleChildernBox from '@/components/shuttleBox/choseStaff.vue';
import { uuid } from '@/util/uuid';

@Component({
  components: { ShuttleBox, ShuttleChildernBox },
})
export default class ApprovalDraw extends Vue {
  get deptTree() {
    return this.$store.state.user.deptTree;
  }
  private visible = false; // drawer是否显示
  private title: any = ''; // drawer标题

  activeName = 'first'; //默认选项卡激活项

  radio = 0; //设置审批人单选按钮
  radioShowUnit = 0; //控制单选显示组件

  value = ''; //表单人联系人下拉数据
  value1 = ''; //发起人自选下拉数据
  value2 = ''; //发起人选择范围下拉数据

  handleAll = ''; //全选绑定值
  newArr: any = []; //每一个选中组成的数组
  data: any;
  uuid: any;

  approvalType: any = 3;

  form: any = {
    approveWay: 'once', // sequential：依次审批 all：会签（须所有审批人同意）once：或签（一名审批人同意或拒绝即可）
    assign: {
      assignWay: '', // staff：指定成员  sponsorChoose：发起人自选  sponsor：发起人自己  deptPrincipal：部门负责人  superDept：上级部门  contactPerson：表单内的“联系人”控件内的人员  dept：部门
    },
  };

  formDesign: any = [];

  choseList: any = [];
  choseStaffList: any = [];

  notFoundHandleWay: any = 'turnManager';

  idToName(id: any, type: any) {
    const arr: any = [];
    let name: any = '';
    if (type === 'staff') {
      this.deptTree.forEach((dept: any) => {
        dept.staffList.forEach((staff: any) => {
          if (id === staff.staffId) {
            name = staff.staffName;
          }
        });
      });
    }
    if (type === 'dept') {
      this.deptTree.forEach((dept: any) => {
        if (id === dept.id) {
          name = dept.name;
        }
      });
    }
    return name;
  }

  private async showDrawer(nodeConfig: any, form: any) {
    // console.log(this.deptTree);
    this.uuid = uuid();
    this.data = nodeConfig;
    if (nodeConfig) {
      this.dataChange(this.data);
    }

    this.formDesign = form;
    this.handleAll = '';
    const arr: any = [];

    form.formData &&
      form.formData.forEach((item: any) => {
        let value: any = '';
        if (nodeConfig.formControlAuth) {
          for (const key in nodeConfig.formControlAuth) {
            if (key === item.form.id) {
              value = nodeConfig.formControlAuth[key];
            }
          }
        }
        arr.push({
          id: item.form.id,
          formField: item.form.label,
          handle: value || 'hide',
          name: item.form.id + this.uuid,
        });
      });
    this.tableData = arr;

    this.visible = true;
    this.title = '办理人';

    console.log(this.form);
  }

  dataChange(data: any) {
    // todo 人员部门选择组件完善后，完成其他类型数据转换
    this.form = data;
    if (!this.form.assign) {
      return false;
    }
    this.choseStaffList = [];
    switch (this.form.assign.assignWay) {
      case 'staff':
        this.radio = 1;
        this.form.assign.staffIdList.forEach((item: any) => {
          this.choseStaffList.push({
            objId: item,
            objName: this.idToName(item, 'staff'),
            type: 'staff',
          });
        });
        // const arr: any = [];
        // this.choseList.forEach((item: any) => {
        //   arr.push(item.objId);
        // });
        //
        // this.form.assign = {
        //   assignWay: 'staff',
        //   staffIdList: arr,
        // };
        break;
      case 'sponsorChoose':
        this.radio = 2;
        this.value1 = this.form.assign.numPeople;
        this.value2 = this.form.assign.scopeType;
        if (this.value2 === 'dept') {
          this.form.assign.memberScopeIdList.forEach((item: any) => {
            this.choseList.push({
              objId: item,
              objName: this.idToName(item, 'dept'),
              type: 'department',
            });
          });
        }
        if (this.value2 === 'staff') {
          this.form.assign.memberScopeIdList.forEach((item: any) => {
            this.choseStaffList.push({
              objId: item,
              objName: this.idToName(item, 'staff'),
              type: 'staff',
            });
          });
        }

        // const arr2: any = [];
        // if (this.value2 === 'dept') {
        //   this.choseList.forEach((item: any) => {
        //     arr2.push(item.objId);
        //   });
        // }
        // if (this.value2 === 'staff') {
        //   this.choseStaffList.forEach((item: any) => {
        //     arr2.push(item.objId);
        //   });
        // }
        // this.form.assign = {
        //   assignWay: 'sponsorChoose',
        //   numPeople: this.value1, // 人数：一人(onePeople),多人（multiplePeople）
        //   scopeType: this.value2, //范围：公司（company）、部门（dept）、指定人员（staff）
        //   memberScopeIdList: arr2, // 部门、指定人员时填写["4d2ac830f7472b87ed814c17669d4975","de1d418f55900fdd9aba1dcdb0916bbc"]
        // };
        break;
      case 'dept':
        this.radio = 3;
        this.form.assign.deptIdList.forEach((item: any) => {
          this.choseList.push({
            objId: item,
            objName: this.idToName(item, 'dept'),
            type: 'dept',
          });
        });
        // this.form.assign = {
        //   assignWay: 'role',
        // };
        break;
      case 'sponsor':
        this.radio = 4;
        // this.form.assign = {
        //   assignWay: 'sponsor',
        // };
        break;
      case 'contactPerson':
        this.radio = 5;
        this.value = this.form.assign.controlId;
        // this.form.assign = {
        //   assignWay: 'contactPerson',
        //   controlId: this.value, // 为联系人类型的控件的id
        // };
        break;
      case 'deptPrincipal':
        this.radio = 6;
        this.notFoundHandleWay = this.form.assign.notFoundHandleWay;
        // this.form.assign = {
        //   assignWay: 'deptPrincipal',
        //   notFoundHandleWay: this.notFoundHandleWay, // 找不到人的处理方式：自动通过("autoPass")、自动转交管理员("turnManager")
        // };
        break;
      case 'superDept':
        this.radio = 7;
        this.notFoundHandleWay = this.form.assign.notFoundHandleWay;
        // this.form.assign = {
        //   assignWay: 'superDept',
        //   notFoundHandleWay: this.notFoundHandleWay, // 找不到人的处理方式：自动通过("autoPass")、自动转交管理员("turnManager")
        // };
        break;
    }
  }

  private saveData() {
    console.log(this.form);
    switch (this.radio) {
      case 1:
        const arr: any = [];
        const arrName: any = [];
        this.choseStaffList.forEach((item: any) => {
          arr.push(item.objId);
          arrName.push(item.objName);
        });

        this.form.assign = {
          assignWay: 'staff',
          staffIdList: arr,
          label: arrName.toString(),
        };
        break;
      case 2:
        const arr2: any = [];
        if (this.value2 === 'dept') {
          this.choseList.forEach((item: any) => {
            arr2.push(item.objId);
          });
        }
        if (this.value2 === 'staff') {
          this.choseStaffList.forEach((item: any) => {
            arr2.push(item.objId);
          });
        }
        this.form.assign = {
          assignWay: 'sponsorChoose',
          numPeople: this.value1, // 人数：一人(onePeople),多人（multiplePeople）
          scopeType: this.value2, //范围：公司（company）、部门（dept）、指定人员（staff）
          memberScopeIdList: arr2, // 部门、指定人员时填写["4d2ac830f7472b87ed814c17669d4975","de1d418f55900fdd9aba1dcdb0916bbc"]
        };
        break;
      case 3:
        const arr3: any = [];
        const arr3Name: any = [];
        this.choseList.forEach((item: any) => {
          arr3.push(item.objId);
          arr3Name.push(item.objName);
        });
        this.form.assign = {
          assignWay: 'dept',
          deptIdList: arr3,
          label: arr3Name.toString(),
        };
        break;
      case 4:
        this.form.assign = {
          assignWay: 'sponsor',
        };
        break;
      case 5:
        const index5: any = this.formDesign.formData.findIndex((item: any) => {
          return item.form.id === this.value;
        });
        this.form.assign = {
          assignWay: 'contactPerson',
          controlId: this.value, // 为联系人类型的控件的id
          label: this.formDesign.formData[index5].form.label,
        };
        break;
      case 6:
        this.form.assign = {
          assignWay: 'deptPrincipal',
          notFoundHandleWay: this.notFoundHandleWay, // 找不到人的处理方式：自动通过("autoPass")、自动转交管理员("turnManager")
        };
        break;
      case 7:
        this.form.assign = {
          assignWay: 'superDept',
          notFoundHandleWay: this.notFoundHandleWay, // 找不到人的处理方式：自动通过("autoPass")、自动转交管理员("turnManager")
        };
        break;
    }

    // 数据传递
    this.data.approveWay = this.form.approveWay;
    this.data.assign = this.form.assign;

    console.log(this.tableData);
    const obj: any = {};
    this.tableData.forEach((item: any) => {
      if (item.handle !== '') {
        obj[item.id] = item.handle;
      }
    });
    console.log(obj);
    this.data.formControlAuth = obj;

    this.$emit('setData', this.data);
    this.visible = false;
  }

  private handleClose() {
    this.visible = false;
  }

  private handleClick(tab: any, event: any) {}

  //表格主体数据
  private tableData: any = [
    {
      id: 1,
      formField: '关联审批单',
      handle: '',
    },
    {
      id: 2,
      formField: '多行输入框',
      handle: '',
    },
    {
      id: 3,
      formField: '金额(元)',
      handle: '',
    },
    {
      id: 4,
      formField: '计算公式',
      handle: '',
    },
    {
      id: 5,
      formField: '电子发票',
      handle: '',
    },
  ];

  /**
   * desc 实现全选
   * */
  allChange() {
    this.tableData.forEach((item: any) => (item.handle = this.handleAll));
  }
  /**
   * desc 选中每一个实现全选
   * params1 e event事件源对象
   * */
  oneChange(e: any) {
    this.newArr = [];
    this.tableData.forEach((item: any) => {
      this.newArr.push(item.handle);
    });
    if (this.newArr.every((item: any) => item === e.target.dataset.type)) {
      this.handleAll = e.target.dataset.type;
    } else {
      this.handleAll = '';
    }
  }

  // editOne() {
  //   this.newArr = []
  //   this.tableData.forEach((item:any)=>{
  //     this.newArr.push(item.handle)
  //   })
  //   if(this.newArr.every((item:any)=>item==='edit')){
  //     this.handleAll='edit'
  //   }else {
  //     this.handleAll = ''
  //   }
  // }

  // readOne() {
  //   this.newArr = []
  //   this.tableData.forEach((item:any)=>{
  //     this.newArr.push(item.handle)
  //   })
  //   if(this.newArr.every((item:any)=>item==='read')){
  //     this.handleAll='read'
  //   }else {
  //     this.handleAll = ''
  //   }
  // }
  // hideOne() {
  //   this.newArr = []
  //   this.tableData.forEach((item:any)=>{
  //     this.newArr.push(item.handle)
  //   })
  //   if(this.newArr.every((item:any)=>item==='hide')){
  //     this.handleAll='hide'
  //   }else {
  //     this.handleAll = ''
  //   }
  // }

  approvalTypeChange(value: any) {}

  approvalChange(value: any) {
    this.choseList = [];
    this.choseStaffList = [];
    this.radioShowUnit = value;
  }
  optionChange(value: number) {
    console.log(value);
  }
  selRangeChange(val: number) {
    this.choseList = [];
    console.log(val);
    console.log();
  }

  choseStaff() {
    // 打开只有部门下级人员的审批弹出框
    const data = this.choseStaffList || [];
    const shuttleChildrenBox = 'shuttleChildrenBox';
    const shuttleChildrenBoxComponent = this.$refs[shuttleChildrenBox];
    (shuttleChildrenBoxComponent as any).showDialog(data);
  }

  choseDept() {
    const shuttleBox = 'shuttleBox';
    const shuttleBoxComponent = this.$refs[shuttleBox];
    (shuttleBoxComponent as any).showDialog(this.choseList);
  }

  checkNodeData(data: any) {
    console.log(data);
    this.choseList = data;
  }

  checkChildrenNodeData(data: any) {
    console.log(data);
    this.choseStaffList = data;
  }
}
